import {darken} from '@mui/material/styles';

export const COLOR__BLACK = '#000';
export const COLOR__MAIN_BLACK = '#171717';
export const COLOR__GRAY = '#636170';
export const COLOR__WHITE = '#fff';
export const COLOR__LIGHT_GRAY = '#98979F';
export const COLOR__LINE = '#CBCDD8';
export const COLOR__BORDER = '#E6E6E6'; // input/button borders
export const COLOR__ERROR_BORDER = '#E12121'; // error state borders
export const COLOR__DISABLED_BG = '#F1F1F1'; // disabled state background
export const COLOR__DISABLED_TEXT = '#D0D2E2'; // disabled state text/border

// Standard backgrounds
export const COLOR__BACK = '#F2F2F2';
export const COLOR__LIGHT_BACK = '#F6F6F6';
export const COLOR__OFF_WHITE = COLOR__WHITE;

// Main colors
export const COLOR__PRIMARY = '#1751D0';
export const COLOR__SECONDARY = '#B65EC8';
export const COLOR__ERROR = '#BC1C1C';
export const COLOR__WARNING = '#FFAB1F';
export const COLOR__INFO = '#3991E5'; // not used in Figma
export const COLOR__SUCCESS = '#019939';
export const COLOR__TEXT_PRIMARY = COLOR__MAIN_BLACK;
export const COLOR__TEXT_SECONDARY = COLOR__GRAY;
export const COLOR__TEXT_DISABLED = `${COLOR__MAIN_BLACK}8F`; // 56% opacity
export const COLOR__MAGENTA = '#B01F80';

export const COLOR__PRIMARY_LIGHT = '#F5F8FD';
export const COLOR__PRIMARY_SOFT_DARK = '#0C296A';
export const COLOR__PRIMARY_DARK = '#081B45';
export const COLOR__SECONDARY_LIGHT = '#F0DFF4';
export const COLOR__SECONDARY_SOFT_DARK = '#631C71';
export const COLOR__SECONDARY_DARK = '#3B0A2B';
export const COLOR__ERROR_LIGHT = '#FFE3E3';
export const COLOR__ERROR_SOFT_DARK = '#711111';
export const COLOR__ERROR_DARK = '#270E05';
export const COLOR__SUCCESS_LIGHT = '#E1FAEA';
export const COLOR__SUCCESS_SOFT_DARK = '#004D1D';
export const COLOR__SUCCESS_DARK = '#102A19';
export const COLOR__WARNING_LIGHT = '#FFF1DA';
export const COLOR__WARNING_SOFT_DARK = '#764C06';
export const COLOR__WARNING_DARK = '#4F3304';
export const COLOR__MAGENTA_LIGHT = '#F5DDED';
export const COLOR__MAGENTA_SOFT_DARK = '#581040';
export const COLOR__MAGENTA_DARK = '#3B0A2B';

export const COLOR__HEADER_BG = darken(COLOR__PRIMARY_LIGHT, 0.05);
